export const BASE_URL = "https://90f396e911fe.ngrok.io";

export const chatId = 3185262264900227;

